<template>
  <div v-if="!item.hidden&&item.children&&enableModule(item.name)" class="menu-wrapper">
    <template v-if="hasOneShowingChild(item.children) && !onlyOneChild.children">
      <a :href="onlyOneChild.path" target="_blank" @click="clickLink(onlyOneChild.path,$event)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
          <icon :name="item.name" scale="2.5" style="background-color: #ffffff; border-radius: 20%;"></icon>
          <span>{{onlyOneChild.meta.title}}</span>
        </el-menu-item>
      </a>
    </template>
    <el-submenu v-else :index="item.name||item.path">
      <template slot="title">
        <icon :name="item.name" scale="2.5" style="background-color: #ffffff; border-radius: 20%;"></icon>
        <span>{{item.meta.title}}</span>
      </template>
      <template v-for="child in item.children" v-if="!child.hidden">
        <sidebar-item v-if="child.children&&child.children.length>0" :is-nest="true" :item="child" :key="child.path"
                      :base-path="resolvePath(child.path)" class="nest-menu" />
        <a v-else :href="child.path" :key="child.name" target="_blank" @click="clickLink(child.path,$event)">
          <el-menu-item :index="resolvePath(child.path)">
            <span>{{child.meta.title}}</span>
          </el-menu-item>
        </a>
      </template>
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { mapGetters } from 'vuex'
import Cookies from 'js-cookie'

let lodash = require('lodash')
export default {
  name: 'SidebarItem',
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      onlyOneChild: null
    }
  },
  computed: {
    ...mapGetters([
      'permission'
    ])
  },
  methods: {
    hasOneShowingChild (children) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // temp set(will be used if only has one showing child )
          this.onlyOneChild = item
          return true
        }
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    resolvePath (routePath) {
      return path.resolve(this.basePath, routePath)
    },
    clickLink (routePath, e) {
      e.preventDefault()
      const path = this.resolvePath(routePath)
      this.$router.push(path)
    },
    enableModule (name) {
      if (lodash.indexOf(Cookies.get('permission').split(','), name) !== -1) {
        return true
      }
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/components/Sidebar/SidebarItem.vue